import GlobalInput from 'modules/Common/Components/GlobalInputs';
import { ChangeEvent } from 'react';
import styled from 'styled-components';
import LinkCampaignSelectInput from '../Components/LinkCampaignSelectInput';
import { ICampaignsName } from 'modules/Campaigns/interfaces';

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  .workflow-select {
    display: flex;
    flex: 1;
    height: 38px;
  }
  .custom-select-wrapper {
    @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
      width: 94%;
    }
  }
  .label {
    padding: 0 8px;
  }
  .css-vqtttq-ValueContainer {
    padding: 0px 8px 0px 0px;
  }
`;

const InputTitle = styled.h2`
  color: #5e7079;
  font-family: 'Roboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.5px;
  margin: 0;
  max-width: 190px;
  white-space: nowrap;
  padding-right: 190px;
  @media all and (max-width: 1439px) {
    font-size: 16px !important;
  }
`;

type Props = {
  formName: string;
  setFormName: (val: string) => void;
  linkedCampaign?: { id: number; name: string };
  setLinkedCampaign?: (val: { id: number; name: string }) => void;
  handleSearchCampaign?: (searchTerm: string) => void;
  campaignsLoadMore?: (val: ICampaignsName[]) => void;
  campaignItems: ICampaignsName[];
  campaignItemsLoading: boolean;
  campaignSearchTerm: string;
};

const CreateFormContent = (props: Props) => {
  // Props
  const {
    formName,
    setFormName,
    linkedCampaign,
    setLinkedCampaign,
    handleSearchCampaign,
    campaignsLoadMore,
    campaignItems,
    campaignItemsLoading,
    campaignSearchTerm,
  } = props;
  // Component Logic
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormName(e.target.value);
  };
  const onUnlinkCampaign = () => {
    setLinkedCampaign && setLinkedCampaign({ id: 0, name: '' });
  };
  return (
    <>
      <ContentWrapper>
        <InputTitle>Name*</InputTitle>
        <GlobalInput
          width=""
          size={'large'}
          placeholder={'Give your form handler a name'}
          prefix={''}
          padding=""
          value={formName}
          handleInputChange={handleInputChange}
          onPressEnter={() => {}}
          bgColor={''}
          border={''}
          color={'#C1C1C1'}
          borderRadius={'8px'}
          suffix={''}
          inputType={'input'}
        />
      </ContentWrapper>
      {/* Select */}
      <ContentWrapper>
        <InputTitle>Link your Campaign</InputTitle>
        <LinkCampaignSelectInput
          isCampaignDropDown
          isCheckbox={false}
          campaigns_list={campaignItems}
          loadingCampaigns={campaignItemsLoading}
          campaignsSearchTerm={campaignSearchTerm}
          handleSearchCampaign={handleSearchCampaign}
          selectedValue={linkedCampaign}
          setSelectedValue={setLinkedCampaign}
          onClickUnlinkCampaign={onUnlinkCampaign}
          loadMore={campaignsLoadMore}
        />
      </ContentWrapper>
    </>
  );
};

export default CreateFormContent;
